import { render } from "./CustomerCreationDialog.vue?vue&type=template&id=c9c4d194"
import script from "./CustomerCreationDialog.vue?vue&type=script&lang=js"
export * from "./CustomerCreationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__